import each from 'lodash-es/each';
import Flickity from 'flickity';

export default () => {
  const slider = document.querySelector('[data-shoppable-modal-products]');
  let carousel = null;
  const carousels = [];

  if (window.theme.breakpoints.current === 'mobile') {
    carousel = new Flickity(slider, {
      wrapAround: true,
      dragThreshold: 10,
      arrowShape:
        'M72.796,0.001c-1.314,0.168 -1.563,0.449 -2.17,0.998l-47.051,47.052l47.211,50.818c1.883,1.878 3.088,1.018 4.202,0.262c1.654,-1.123 1.921,-3.596 0.588,-5.185l-42.451,-45.718l42.598,-42.624c1.653,-2.251 0.05,-5.678 -2.927,-5.603Z',
    });
    carousels.push(carousel);
  }

  document.addEventListener(
    'shoppableImageDidClose',
    () => {
      each(carousels, (_carousel) => {
        _carousel.destroy();
      });
    },
    { once: true },
  );

  window.addEventListener('breakpointChange', () => {
    if (window.theme.breakpoints.current === 'mobile') {
      carousel = new Flickity(slider, {
        wrapAround: true,
        dragThreshold: 10,
        arrowShape:
          'M72.796,0.001c-1.314,0.168 -1.563,0.449 -2.17,0.998l-47.051,47.052l47.211,50.818c1.883,1.878 3.088,1.018 4.202,0.262c1.654,-1.123 1.921,-3.596 0.588,-5.185l-42.451,-45.718l42.598,-42.624c1.653,-2.251 0.05,-5.678 -2.927,-5.603Z',
      });
      carousels.push(carousel);
    } else {
      each(carousels, (_carousel) => {
        _carousel.destroy();
      });
    }
  });
};
